import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from "swiper";
import clsx from 'clsx';

import 'swiper/css';
import 'swiper/css/scrollbar';

import { Mousewheel, Scrollbar } from 'swiper/modules';
import { motion } from 'framer-motion';
import Container from 'components/Container';
type PortfolioType = {
    title: string;
    link: string;
    image: string;
}


const PortfolioItem = ({ portfolio }: { portfolio: PortfolioType }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <motion.div
            className="border-neutral-600 border-4 rounded-2xl overflow-hidden relative"
            onHoverStart={() => setIsHovered(true)}
            onHoverEnd={() => setIsHovered(false)}
        >
            <div className="card"
                style={{
                    background:
                        "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.924829306722689) 90%)",
                }}>
                <a href={`/portfolio/${portfolio?.title}`}
                    className="mt-auto p-3 md:p-5 w-full flex flex-row justify-between absolute bottom-0 z-20 text-space">
                    <h4 className="font-nebulica text-3xl md:text-4xl text-[#FBF4E5] font-bold capitalize">
                        {portfolio.title}
                    </h4>
                    <img className='w-6 h-6 object-cover my-auto' src="/pettern/arrow-right.svg" alt="" />
                </a>
            </div>
            {
                portfolio.image ? (
                    <img
                        src={`/assets/images/portfolio/${portfolio.image}`}
                        className="w-full h-full"
                        alt={portfolio.title || "Portfolio Image"}
                    />
                ) : (
                    <img
                        src="/assets/images/default.webp"
                        className="w-full h-full"
                        alt="Default Image"
                    />
                )
            }
        </motion.div >
    );
};

export default function SliderSlider({
    portfolios,
    showSmall,
    sliderClass = "",
    swiperClass = "",
}: {
    portfolios: PortfolioType[];
    showSmall?: boolean;
    sliderClass?: string;
    swiperClass?: string;
}) {
    return (
        <div className={clsx(
            "",
            sliderClass,
            {
                "": !!sliderClass,
            }
        )}>
            <Container className="mb-6 2xl:mb-12">
                <Swiper
                    scrollbar={{
                        hide: true,
                    }} mousewheel={true}
                    modules={[Mousewheel, Scrollbar]}
                    slidesPerView={
                        window.innerWidth < 1024 ? 1 : window.innerWidth < 1280 ? 2 : window.innerWidth < 2000 ? 3 : 4
                    }
                    onResize={(swiper: SwiperType) => {
                        swiper.params.slidesPerView =
                            window.innerWidth < 1024 ? 1 : window.innerWidth < 1280 ? 2 : window.innerWidth < 2000 ? 3 : 4;
                    }}
                    spaceBetween={30}
                    className={clsx(
                        "slider",
                        swiperClass,
                        {
                            "": !!swiperClass,
                        }
                    )}
                >
                    {portfolios
                        .slice(0, showSmall ? 4 : portfolios.length)
                        .map((portfolio, index) => (
                            <SwiperSlide key={index}>
                                <PortfolioItem portfolio={portfolio} />
                            </SwiperSlide>
                        ))}
                </Swiper>
            </Container>
        </div >
    );
}